import { Modal } from "../../../../design-system/organisms/Modal";
import { Button } from "../../../../design-system/atoms/Button";
import { toast } from "react-toastify";
import {
  ModuleFragment,
  useEjectModulePowerBanksMutation,
} from "../../../../data/generated";
import styled from "styled-components";

export const EjectPowerBanksModal = ({
  module,
  onClose,
}: {
  module: ModuleFragment;
  onClose: () => void;
}) => {
  const [ejectModulePowerBanksMutation] = useEjectModulePowerBanksMutation({
    variables: { serialNumber: module.serialNumber },
  });

  async function ejectPowerBanks() {
    const { data } = await ejectModulePowerBanksMutation();

    if (!data) {
      toast.error("An unexpected error occurred");
      return;
    }

    const {
      ejectModulePowerBanks: { success, error },
    } = data;

    if (error) {
      toast.error(error);
      return;
    }

    if (!success) {
      toast.error("An unexpected error occurred");
      return;
    }

    toast.success("Power banks popped out successfully");
    onClose();
  }

  return (
    <Modal title="Eject module power banks" onClose={onClose}>
      <ContentContainer>
        You're about to eject all power banks of the module with Serial Number{" "}
        {module.serialNumber}.<Button onClick={ejectPowerBanks}>Confirm</Button>
      </ContentContainer>
    </Modal>
  );
};

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
